var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.15261837610274,
    height: 46.15261837610274,
    viewBox: "144.02955367913148 236.92369081194352 46.15261837610274 46.15261837610274",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6654003158 0 0 0.6654003158 167.1058628672 260)",
    id: "OOVSsg94fU6iT_gkuvLVs"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(39,236,227)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,234)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0 -34.68034 C 19.14355 -34.68034 34.68034 -19.14355 34.68034 0 C 34.68034 19.14355 19.14355 34.68034 0 34.68034 C -19.14355 34.68034 -34.68034 19.14355 -34.68034 0 C -34.68034 -19.14355 -19.14355 -34.68034 0 -34.68034 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 167.1058628672 260)",
    id: "GFDFEfssZOGVIfMDb-WN3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.353235 -6.5625)",
    id: "oJG-G5gvj49mX9W32cXVU"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.146765, -8.4375)",
    d: "M 15.1467 2.5 C 11.8607 2.5 9.19693 5.15831 9.19693 8.4375 C 9.19693 11.7167 11.8607 14.375 15.1467 14.375 C 18.4327 14.375 21.0966 11.7167 21.0966 8.4375 C 21.0966 5.15831 18.4327 2.5 15.1467 2.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.353275 7.1875)",
    id: "JvubaeeVQLkOz8XxaAbCt"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,32,32)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.146725, -22.1875)",
    d: "M 11.389 16.25 C 8.10297 16.25 5.43915 18.9083 5.43915 22.1875 C 5.43915 25.4667 8.10297 28.125 11.389 28.125 L 18.9045 28.125 C 22.1905 28.125 24.8543 25.4667 24.8543 22.1875 C 24.8543 18.9083 22.1905 16.25 18.9045 16.25 L 11.389 16.25 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.0cb2ac76cf364699f48adcddcbf20ff8.svg";
export { ForwardRef as ReactComponent };